import { defaultDetailData } from '@/components/calculators/power-kits/components/Step456/DetailsModal';
import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { Modal } from 'antd';
import css from './detailsmodal.module.scss';
export default function DetailsModalH5({ isShow = true, data = defaultDetailData, callBack }: any) {
    const { useLang, useState, useEffect } = useGlobal();
    const [visible, setVisible] = useState(isShow);
    const { t } = useLang('shared');

    useEffect(() => {
        setVisible(isShow);
    }, [isShow]);

    const handleClose = () => {
        callBack(false);
    };

    const getBrowserInterfaceSize = () => {
        let pageWidth = window.innerWidth;
        let pageHeight = window.innerHeight;

        if (typeof pageWidth != 'number') {
            if (document.compatMode == 'CSS1Compat') {
                pageWidth = document.documentElement.clientWidth;
                pageHeight = document.documentElement.clientHeight;
            } else {
                pageWidth = document.body.clientWidth;
                pageHeight = document.body.clientHeight;
            }
        }

        return {
            pageWidth,
            pageHeight,
        };
    };
    useEffect(() => {
        if (window && document) {
            const targetEl = document.querySelector('.calculators-mm100-step4-detailsModalH5 .ant-modal');
            if (targetEl) {
                targetEl.style.height = `${getBrowserInterfaceSize().pageHeight}px`;
            }
        }
    }, []);

    return (
        <Modal
            width={'3.75rem'}
            closable={false}
            wrapClassName={`calculators-mm100-step4-detailsModalH5 ${css.calculatorsmm100step4detailsModalH5}`}
            visible={visible}
        >
            <div className="title-area">
                <span className="detailModal-closeBtn" onClick={handleClose}>
                    ×
                </span>
                <h2 className="detailModal-title">{t('calculators.mm100.step4.detail')}</h2>
            </div>
            <div className="detailModal-img">
                <Image src={data?.imgH5} layout="fill" className="fullImgs" alt={data?.title} aria-label={data.title} />
            </div>
            <div className="detailModal-detailInfo">
                <h3 className="info-tittle">{data?.title}</h3>
                <p className="info-desc">{data?.desc}</p>
                {data?.specParams?.length > 0 && (
                    <div className="infoSpec">
                        <h3 className="spec-title">{t('calculators.mm100.step4.spec')}</h3>
                        <ul className="specs">
                            {data?.specParams?.map((spec: any, k: number) => (
                                <li className="spec-item" key={k}>
                                    <p className="spec-item-name">{spec?.key}</p>
                                    <p className="spec-item-content">{spec?.value}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </Modal>
    );
}
